import { Subscribe } from '@react-rxjs/core'
import React, { useEffect } from 'react'

import { SanityDispensaryFeaturedProducts } from '../../../graphql/gatsby'
import useIsSsr from '../../../hooks/useIsSsr'
import { useSanityRoleBasedContent } from '../../../lib/sanity'
import {
  latestFeaturedProducts$,
  searchFeaturedProducts,
} from '../../../lib/sanity-dispensaries/featured-products'
import Spinner from '../../Spinner'
import { FeaturedProducts } from './featured-products'

export interface DispensaryFeaturedProductsProps extends SanityDispensaryFeaturedProducts {
  className?: string
}

const DispensaryFeaturedProducts: React.FC<DispensaryFeaturedProductsProps> = ({
  forceDefault,
  roleBasedContent,
}) => {
  // Suspense not supported server-side yet
  const isSsr = useIsSsr()
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })

  const shouldDisplayContent = shouldDisplay && !isSsr

  useEffect(() => {
    if (shouldDisplayContent) {
      searchFeaturedProducts({ forceDefault: forceDefault ?? false })
    }
  }, [shouldDisplayContent, forceDefault])

  if (!shouldDisplayContent) {
    return null
  }

  return (
    <Subscribe source$={latestFeaturedProducts$} fallback={<Spinner loading />}>
      <FeaturedProducts />
    </Subscribe>
  )
}

export default DispensaryFeaturedProducts
